const permission = {
  tree: [{
    id: 100,
    label: 'Lists',
    children: [
      {
        id: 110,
        label: 'Normal'
      },
      {
        id: 120,
        label: 'Nested'
      },
      {
        id: 130,
        label: 'Parallel'
      }
    ]
  }]
}

const list = {
  total: 4,
  list: [
    {
      id: 1,
      email: 'a@example.com',
      phone: '16612345678',
      status: 0,
      flag: 1,
      ctime: 1.5e9,
      last_login: 1.5e9,
      role_list: [1, 2, 3, 4],
      role_name_list: ['All Permission', 'Normal', 'Nested', 'Parallel']
    },
    {
      id: 2,
      email: 'b@example.com',
      phone: '16623456781',
      status: 0,
      flag: 1,
      ctime: 1.5e9,
      last_login: 1.5e9,
      role_list: [1, 2, 3, 4],
      role_name_list: ['All Permission', 'Normal', 'Nested', 'Parallel']
    },
    {
      id: 3,
      email: 'c@example.com',
      phone: '16634567812',
      status: 1,
      flag: 1,
      ctime: 1.5e9,
      last_login: 1.5e9,
      role_list: [1, 2, 3, 4],
      role_name_list: ['All Permission', 'Normal', 'Nested', 'Parallel']
    },
    {
      id: 4,
      email: 'd@example.com',
      phone: '16645678123',
      status: 0,
      flag: 0,
      ctime: 1.5e9,
      last_login: 1.5e9,
      role_list: [1, 2, 3, 4],
      role_name_list: ['All Permission', 'Normal', 'Nested', 'Parallel']
    }
  ]
}

export default { permission, list }



// WEBPACK FOOTER //
// ./examples/mock/user.js